import { APIPath } from '../constants';
import { BaseService } from './base';
import { CRUDService } from './crud.ts';

class Public extends CRUDService {
  constructor() {
    super(APIPath.public);
  }

  getAppVersion() {
    return BaseService.get(APIPath.publicAppVerion, false, false);
  }
}

const PublicService = new Public();
Object.freeze(PublicService);
export { PublicService };
